module.exports = __webpack_public_path__ + "img/content.9d96556b.png";